import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SliderUpdate } from '../../services';

export const fetchSliderUpdate = createAsyncThunk(
    'sliderUpdate/fetchSliderUpdate',
    async ({ id, filesToKeep, file, title, slug, sliderGroupId, sort }) => {
        const response = await SliderUpdate(id, file, title, slug, sliderGroupId, sort, filesToKeep)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const sliderUpdateSlice = createSlice({
    name: 'sliderUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderUpdateSlice.reducer;
